var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"reg-success-label"},[_c('div',{staticClass:"panel panel-default reg-success"},[_c('div',{staticClass:"panel-body"},[_c('h3',{staticClass:"text-center"},[_vm._v("Ваш аккаунт заблокирован!")]),_c('p',[_vm._v(" Видимо что-то пошло не так и мы заблокировали ваш аккаунт, письмо с объеснением причин отправлено на вашу почту. ")])])])])])
}]

export { render, staticRenderFns }